var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShortGameActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 43,
    viewBox: "0 0 19 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5094 0C17.7935 0 18.0229 0.228429 18.0229 0.511347V40.9581C18.0229 40.9581 18.0187 40.9728 18.0187 40.979C17.8546 40.9937 17.6841 41 17.5115 41C17.3389 41 17.1684 40.9937 17.0042 40.979C17.0042 40.9728 17 40.9644 17 40.9581V0.511347C17 0.228429 17.2294 0 17.5136 0H17.5094Z",
    fill: "#B3D3E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.41389C5.60127 0.359867 12.3987 5.05402 18 0V1.41566C18 1.41566 16.1021 3.7548 16.1021 6.23682C16.1021 8.71885 18 10.2456 18 10.2456V10.8304C12.3987 12.2752 5.60127 3.97178 0 5.41654V5.41389Z",
    fill: "#006AB3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 41C10 42.1035 11.7911 43 14 43C16.2089 43 18 42.1035 18 41C18 39.8966 16.2089 39 14 39C11.7911 39 10 39.8966 10 41Z",
    fill: "#006AB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortGameActiveIcon);
export default __webpack_public_path__ + "static/media/shortGameActiveIcon.ab8263b29621075d5802ef4dfbf6b867.svg";
export { ForwardRef as ReactComponent };